import { browserHistory } from "react-router";
import { delay, call, put, select, takeEvery } from "redux-saga/effects";

import * as api from "../../services/supplier/api_supplier";
import * as apiCommon from "../../services/apiCommon";
import * as common from "../sagasCommon";
import * as actionType from "../../constants/constant_action_types";
import { ENTITY, ENTITY_TYPE } from "../../constants/constant_doc_types";
import { SUPPLIER } from "../../constants/constant_entity_types";
import * as utilityPreference from "../../services/preference/utilty_preference";
import { attachStandardFieldValuesToCustomForm } from "../../services/apiUtils";
import { precheckEntity } from "../sagasCommonEntity";

export function* fetchListSupplierSaga(feathersApp) {
  yield takeEvery("FETCH_LIST_SUPPLIERS", callListSupplier, feathersApp);
}

function* callListSupplier(feathersApp, action) {
  const { filters, silent } = action;
  yield delay(2000);
  yield common.showProgressListTable(silent);
  try {
    const dataParams = {
      filters,
      doc_type: "entity/supplier"
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(common.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total
    });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function* deleteSupplierFromListSaga(feathersApp) {
  yield takeEvery(
    "DELETE_SUPPLIER_FROM_LIST",
    callDeleteSupplierFromList,
    feathersApp
  );
}

function* callDeleteSupplierFromList(feathersApp, action) {
  yield deleteSupplier(feathersApp, action);
  yield delay(2000);
  yield callListSupplier(feathersApp, { silent: true });
}

function* deleteSupplier(feathersApp, action) {
  yield common.showProgressDeleteRecord();
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const state = yield select();
      const { tenant, user } = state;
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(api.deleteSupplier, feathersApp, params);
    }
    yield common.doneDeleteRecord(id, ENTITY);
    return result;
  } catch (error) {
    yield common.showErrorDeleteRecord(error);
  }
}

export function* deleteSupplierSaga(feathersApp) {
  yield takeEvery("DELETE_SUPPLIER", callDeleteSupplier, feathersApp);
}

function* callDeleteSupplier(feathersApp, action) {
  const result = yield deleteSupplier(feathersApp, action);
  yield delay(2000);
  if (result) {
    browserHistory.push("/admin/supplier");
  }
}

export function* fetchSupplierForEditSaga(feathersApp) {
  yield takeEvery(
    "FETCH_SUPPLIER_FOR_EDIT",
    callFetchSupplierForEdit,
    feathersApp
  );
}

function* callFetchSupplierForEdit(feathersApp, action) {
  const { tenant, user, intl, subsidiary, path } = yield select();
  const { id, silent } = action;
  yield common.showProgressDataById(silent);

  try {
    let data;

    if (id) {
      // FETCH DOCS FOR PURCHASES
      yield put({
        type: actionType.GET_ENTITY_PURCHASE_ORDERS,
        filters: { supplier: { _id: id } }
      });
      yield put({
        type: actionType.GET_ENTITY_PURCHASE_RECEIPTS,
        filters: { supplier: { _id: id } }
      });
      yield put({
        type: actionType.GET_ENTITY_INVENTORY_RETURN,
        filters: { supplier: { _id: id } }
      });

      const fetchParams = { tenant, user, id, path };
      const doc = yield call(
        api.fetchSupplierForEdit,
        feathersApp,
        fetchParams
      );

      (doc.contact_numbers || []).reverse();
      (doc.address_details || []).reverse();

      doc.custom_fields = yield call(
        attachStandardFieldValuesToCustomForm,
        doc,
        ENTITY,
      );

      data = doc;
    } else {
      const entityTypesParams = { cid: [SUPPLIER] };
      const entityTypes = yield call(
        apiCommon.queryDocs,
        feathersApp,
        ENTITY_TYPE,
        entityTypesParams
      );
      const accountId = (tenant || {}).id;
      const subsidiaryId =
        subsidiary.primary_subsidiary.id || subsidiary.primary_subsidiary._id;
      const defaultCurrency = subsidiary.primary_subsidiary.currency || {};
      const preferenceParams = {
        accountId,
        subsidiaryId,
        intl,
        settings: ['default_price_level', 'default_entity_loyalty'],
      };
      const preferences = yield call(
        utilityPreference.getPreferenceValues,
        feathersApp,
        preferenceParams
      );

      const initialValues = {
        entity_type_ids: entityTypes.data.length
          ? [entityTypes.data[0].id]
          : [],
        loyalty_member: preferences.default_entity_loyalty,
        active: true,
        is_company: true,
        loyalty_points_available: 0,
        contact_numbers: [{ primary: true, type: 'work' }],
        price_level_id: preferences.default_entity_loyalty
          ? preferences.default_price_level
          : undefined,
        preferred_currency_id: defaultCurrency.id,
        preferred_currency: defaultCurrency,
        loyalty_anniversary: preferences.default_entity_loyalty
          ? new Date()
          : undefined,
      };
      
      data = initialValues;
    }

    yield common.doneDataById(data);
  } catch (error) {
    yield common.showErrorDataById(error);
  }
}

export function* saveSupplierSaga(feathersApp) {
  yield takeEvery("SAVE_SUPPLIER", callSaveSupplier, feathersApp);
}
function* callSaveSupplier(feathersApp, action) {
  yield common.showProgressSaveRecord();
  const { tenant, user } = yield select();
  try {
    const ok = yield precheckEntity(feathersApp, action);
    if (!ok) {
      yield common.doneSaveRecord();
      return;
    }

    let result = yield call(api.saveSupplier, feathersApp, {
      tenant,
      user,
      data: action.data,
    });

    const id = result.id;

    yield callFetchSupplierForEdit(feathersApp, { id, silent: true });
    browserHistory.push(`/admin/supplier/edit/${id}`);
    yield common.doneSaveRecord(result, "Supplier was saved");
  } catch (error) {
    yield common.showErrorSaveRecord(error);
  }
}
